import {NavigationService} from "../../Services/NavigationService";
import {StateParams} from "angular-ui-router";
import {ScannerService} from "../../Services/ScannerService";
import {CameraService} from "../../Services/CameraService";
import {Form} from "../../Models/form";
import {ExpenseDataService} from "../../Services/ExpenseDataService";
import {EExternalProjectType, ExpenseType, IExpenseVm} from "../../Data/Data";
import {SaveDialog} from "../../Models/save-dialog";
import {DeleteDialog} from "../../Models/delete-dialog";
import {Triarc} from "../../../Cirrus/utils/CommonUtils";
import {IPromise} from "angular";
import {WaitDialog} from "../../Models/wait-dialog";
import {ExpenseTypeDialog, getExpenseTypeLabel, getExpenseUnit} from "../../Models/expense-type-dialog";

export class ExpenseDetailController {
    static controllerId = "ExpenseDetailController";
    static $inject = [
        '$scope',
        '$stateParams',
        ExpenseDataService.serviceId,
        NavigationService.serviceId,
        ScannerService.serviceId,
        CameraService.serviceId,
    ];

    private readonly userId: number;
    private readonly expenseId: number;

    expense: IExpenseVm;

    form = new Form();
    loading = true;

    deleteDialog = new DeleteDialog();
    saveDialog = new SaveDialog();
    waitDialog = new WaitDialog();
    expenseTypeDialog = new ExpenseTypeDialog();

    constructor(private $scope: ng.IScope,
                $stateParams: StateParams,
                private expenseData: ExpenseDataService,
                private navigation: NavigationService,
                private scanner: ScannerService,
                private camera: CameraService) {
        this.userId = $stateParams['userId'];
        this.expenseId = parseInt($stateParams['expenseId']) || null;

        if (this.isNew) {
            this.expense = <IExpenseVm>{
                id: null,
                date: new Date(),
                project: {externalType: EExternalProjectType.Proj},
                expenseType: ExpenseType.Default,
            };
            this.loading = false;
        } else {
            this.expenseData.get(this.expenseId).then(expense => {
                this.expense = expense;
                this.loading = false;
            });
        }

        this.form.add('date', () => this.expense.date)
            .isRequired();

        this.form.add('projectno', () => this.expense.project.externalId)
            .isNumber()
            .isRequired();

        this.form.add('amount', () => this.expense.amount)
            .isRequired();
    }

    get isNew() {
        return this.expenseId === null || this.expenseId === undefined;
    }

    goBack() {
        this.navigation.goToState('expense-list', {userId: this.userId});
    }

    async scanProjectNo() {
        this.waitDialog.open('Scanner wird geladen...', () => this.scanner.scanProject()).then(result => {
            this.$scope.$apply(() => {
                if (!result.value) {
                    // empty, nothing selected
                } else if (result.type !== EExternalProjectType.Proj) {
                    alert("Spesen dürfen nur auf Projekte erfasst werden");
                } else {
                    this.expense.project.externalId = result.value;
                    this.expense.project.externalType = result.type;
                }
            });
        });
    }

    async albumPicture() {
        this.waitDialog.open('Bitte warten...', () => this.camera.albumPicture()).then(result => {
            this.expense.image = result.base64String;
        });
    }

    async takePicture() {
        this.waitDialog.open('Bitte warten...', () => this.camera.takePicture()).then(result => {
            this.expense.image = result.base64String;
        });
    }

    clearImage() {
        this.expense.image = null;
    }

    save() {
        if (!this.form.isValid()) {
            return;
        }

        let factory: () => IPromise<any>;
        if (this.isNew) {

            const dto = {
                date: this.expense.date,
                projectId: this.expense.project.externalId,
                amount: this.expense.amount,
                employeeId: this.userId,
                expenseText: this.expense.expenseText,
                expenseType: this.expense.expenseType,
                fileType: null,
                fileName: null,
                image: null,
            };

            if (this.needsImage()) {
                dto.fileType = '';
                dto.fileName = `${Triarc.generateGuid()}.jpg`;
                dto.image = this.expense.image;
            }

            factory = () => this.expenseData.create(dto);
        } else {
            factory = () => this.expenseData.save(this.expense);
        }

        this.saveDialog.open(factory).then(() => {
            this.goBack();
        });
    }

    delete() {
        const factory: any = () => this.expenseData.delete(this.expenseId);
        this.deleteDialog.open(factory).then(res => {
            if (res) {
                this.goBack();
            }
        });
    }

    getTypeName() {
        if (this.expense) {
            return getExpenseTypeLabel(this.expense.expenseType);
        }
        return '';
    }

    openExpenseTypeDialog() {
        this.expenseTypeDialog.open((value) => {
            this.expense.expenseType = value;
        });
    }

    needsImage() {
        if (this.expense) {
            return this.expense.expenseType === ExpenseType.Default;
        }
        return false;
    }

    getUnit() {
        if (this.expense) {
            return getExpenseUnit(this.expense.expenseType);
        }
        return '';
    }

    getAmountLabel() {
        if (!this.expense) {
            return '';
        }
        if (this.expense.expenseType === ExpenseType.Default) {
            return 'Betrag';
        }

        return 'Anzahl';
    }
}
